/**
 * Event bus minimale (window CustomEvent) per avvisare chi mostra il riepilogo
 * approvazioni (Sidebar, ApprovazioniView, Dashboard) che deve ricaricarlo.
 * Chi approva/rifiuta/abbina chiama `emitApprovazioniChanged()`; chi mostra un
 * conteggio si iscrive con `subscribeApprovazioniChanged(cb)` e rifà la fetch.
 */

const EVENT_CHANGED = 'approvazioni:changed';
// Emesso dal bottone "Aggiorna" del container: i sotto-tab ricaricano la propria
// lista. È separato da `changed` per evitare loop di refetch.
const EVENT_REFRESH_REQUESTED = 'approvazioni:refresh-requested';

export function emitApprovazioniChanged(): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(EVENT_CHANGED));
}

export function emitApprovazioniRefreshRequested(): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(EVENT_REFRESH_REQUESTED));
}

/** Iscrive `cb` all'evento "changed". Ritorna la funzione di unsubscribe. */
export function subscribeApprovazioniChanged(cb: () => void): () => void {
    if (typeof window === 'undefined') return () => {};
    const handler = () => { cb(); };
    window.addEventListener(EVENT_CHANGED, handler);
    return () => window.removeEventListener(EVENT_CHANGED, handler);
}

/** Iscrive `cb` all'evento "refresh-requested" (bottone globale di refresh). */
export function subscribeApprovazioniRefreshRequested(cb: () => void): () => void {
    if (typeof window === 'undefined') return () => {};
    const handler = () => { cb(); };
    window.addEventListener(EVENT_REFRESH_REQUESTED, handler);
    return () => window.removeEventListener(EVENT_REFRESH_REQUESTED, handler);
}
